<mat-form-field
    [formGroup]="form"
    appearance="outline"
    color="primary"
    class="input-field"
    [class]="field.className"
    [floatLabel]="getFloatLabelState(field.alwaysShowPlaceholder)"
    subscriptSizing="dynamic"
>
    @if(field.label) {
        <mat-label [class]="field.labelClassName">{{field.label}}</mat-label>
    }

    @if (field.internalFields.length) {
        <lib-lookup-field [field]="this.field.internalFields[0]" [form]="form" matSuffix class="lookup-field-nested" />
    }

    <input
        matInput
        [placeholder]="field.placeholder"
        [id]="field.key"
        [type]="field.variant || 'text'"
        [min]="min"
        [formControlName]="field.key"
        [readonly]="field.readonly"
        [name]="field.key"
        [value]="field.value"
    />
</mat-form-field>